import { format } from "date-fns";
import { select } from "redux-saga/effects";

import { DateFormat } from "constants/date";
import { Filter } from "constants/filters";
import { ReportDistribution } from "constants/reports/distribution";
import { calculatePercentageValue } from "helpers/numbers";
import { ITicketRatings, ITicketRatingsPerEntity } from "services/api/report/interfaces";

import { ITicketRatingsData } from "../interfaces";
import { getFilters } from "../selectors";

import { rankingDeserializer } from "./ranking-deserializer";
import { ratingDeserializer } from "./rating-deserializer";

function mapToArray(data: Record<string, ITicketRatings>): ITicketRatingsPerEntity[] {
  return Object.entries(data).map(([id, values]) => {
    const total = values.neutral + values.bad + values.good;
    return {
      id,
      ...values,
      good: calculatePercentageValue(values.good, total),
      goodCount: values.good,
      neutral: calculatePercentageValue(values.neutral, total),
      neutralCount: values.neutral,
      bad: calculatePercentageValue(values.bad, total),
      badCount: values.bad,
      total,
    };
  });
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function* ticketRatingsDeserializer({ data }: any, distribution: ReportDistribution): any {
  const filters = yield select(getFilters);
  const dateFrom = format(filters[Filter.DateRange].from, DateFormat.HtmlInputDate);
  const dateTo = format(filters[Filter.DateRange].to, DateFormat.HtmlInputDate);
  const tag = filters[Filter.Tag];
  const ranking = yield rankingDeserializer(data.ticketsRankingResponse || [], {
    dateFrom,
    dateTo,
    tag,
  });

  const ticketRating = ratingDeserializer(data.ticketsRatingResponse, distribution);
  const totalRatedNeutral = ticketRating.summary[1].value;
  const totalRatedBad = ticketRating.summary[2].value;
  const totalRatedGood = ticketRating.summary[0].value;
  const totalRating = {
    id: "total",
    neutral: totalRatedNeutral,
    bad: totalRatedBad,
    good: totalRatedGood,
  };

  const ratingData: ITicketRatingsData = {
    ranking,
    ticketRating,
    ticketRatingPerTeam: mapToArray({ totalRating, ...data.ticketsRatingResponsePerTeam }),
    ticketRatingPerAgent: mapToArray({ totalRating, ...data.ticketsRatingResponsePerAgent }),
  };

  return ratingData;
}
